export const defaultNetworkCodeSelector = state => {
    return state.entities.defaultNetworkCodeList;
};
